import { Component, OnInit } from '@angular/core';
import { ProfileActionsComponent } from '../profile-actions/profile-actions.component';
import { CollapsiblePanelEvent } from '@edassist-ui/collapsible-panel';

@Component({
	selector: 'tu-profile-actions-mobile',
	templateUrl: './profile-actions-mobile.component.html',
	styleUrls: ['../tuition-mobile-menu/tuition-mobile-menu.component.scss']
})
export class ProfileActionsMobileComponent
	extends ProfileActionsComponent
	implements OnInit
{
	isProfileActionsToggled = false;

	ngOnInit(): void {
		super.ngOnInit();
	}

	handleToggle(): void {
		this.isProfileActionsToggled = !this.isProfileActionsToggled;
	}
}
